// extracted by mini-css-extract-plugin
export default {"container":"MyPage_container__9OINt","heading":"MyPage_heading__sM3Qw","callAPIGrid":"MyPage_callAPIGrid__EOAFT"};